module.exports = __webpack_public_path__ + "static/media/loader.9a38a7c4.svg";